import { isArray } from "lodash";

export const sortByKey = (items, key) => {
  let sortedArray = [];

  if (!isArray(items)) return;

  sortedArray = items.sort(function (a, b) {
    if (a[key] > b[key]) {
      return 1;
    }
    if (a[key] < b[key]) {
      return -1;
    }

    return 0;
  });

  return sortedArray;
};
